import { render, staticRenderFns } from "./PointsAccManagement.vue?vue&type=template&id=2c5ef89b&scoped=true"
import script from "./PointsAccManagement.vue?vue&type=script&lang=js"
export * from "./PointsAccManagement.vue?vue&type=script&lang=js"
import style0 from "./PointsAccManagement.vue?vue&type=style&index=0&id=2c5ef89b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ef89b",
  null
  
)

export default component.exports